var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "h-full",
    viewBox: "0 0 19 24",
    fill: "#FF0000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79191 23.1961C2.16681 13.5966 0.937073 12.6114 0.937073 9.08349C0.937073 4.25099 4.85661 0.333496 9.69163 0.333496C14.5267 0.333496 18.4462 4.25099 18.4462 9.08349C18.4462 12.6114 17.2164 13.5966 10.5913 23.1961C10.1566 23.8238 9.22663 23.8237 8.79191 23.1961ZM9.69163 12.7293C11.7062 12.7293 13.3394 11.097 13.3394 9.08349C13.3394 7.06995 11.7062 5.43766 9.69163 5.43766C7.67703 5.43766 6.0439 7.06995 6.0439 9.08349C6.0439 11.097 7.67703 12.7293 9.69163 12.7293Z",
    height: "100%"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.488537b2faa6bfbe02e9d5702fc54038.svg";
export { ForwardRef as ReactComponent };